






































































import Vue from 'vue';
import Component from 'vue-class-component';
import { mapState } from 'vuex';
import ItemService from '../services/itemService';
import UserService from '../services/userService';
import { AuthenticationModuleState, Item, User } from '../types';

@Component({
  props: {
    item: Object
  },
  computed: {
    ...mapState<AuthenticationModuleState>('authenticationModule', {
      localUser: (state: AuthenticationModuleState) => state.localUser
    })
  }
})
export default class ShowItem extends Vue {
  public itemService: ItemService | null = null;
  public userService: UserService | null = null;
  public isInDeleteConfirmationMode: boolean = false;
  public errorMessage: string | null = null;
  public purchasedByUsername: string | null = null;

  public mounted(): void {
    this.itemService = new ItemService();
    this.userService = new UserService();

    this.updatePurchasedByUsername();
  }

  public updatePurchasedByUsername(): void {
    const thisItem: Item = this.$props.item;
    if (!thisItem.purchasedByUserID) {
      return;
    }

    if (!this.userService) {
      throw new Error('ShowItem.updatePurchasedByUsername: userService is null or undefined');
    }

    this.userService.getUserByID(thisItem.purchasedByUserID)
      .then((user: User) => {
        this.errorMessage = null;
        this.purchasedByUsername = user.username;
      })
      .catch((reason: Error) => {
        this.errorMessage = reason.message;
      });
  }

  public onEdit(): void {
    this.$emit('edit-pressed', this.$props.item);
  }

  public onDeleteConfirm(): void {
    if (!this.itemService) {
      throw new Error('ShowItem.onDeleteConfirm: itemService is null or undefined');
    }

    this.itemService.deleteItemWithID(this.$props.item._id)
      .then(() => {
        this.errorMessage = null;
        this.$emit('item-deleted');
      })
      .catch((reason: Error) => {
        console.error(`Failed to delete item with ID ${this.$props.item._id}: Reason: ${reason}`);
        this.errorMessage = reason.message;
      });
  }

  public onMarkAsPurchased(): void {
    if (!this.itemService) {
      throw new Error('ShowItem.onMarkAsPurchased: itemService is null or undefined');
    }

    const updatedItem: Item = this.$props.item;
    updatedItem.purchasedByUserID = this.$store.state.authenticationModule.localUser._id;

    this.itemService.updateItem(updatedItem)
      .then(() => {
        this.errorMessage = null;
        this.updatePurchasedByUsername();
        this.$emit('item-purchased');
      })
      .catch((reason: Error) => {
        console.error(`Failed to mark item as purchased: ${updatedItem}: Reason: ${reason}`);
        this.errorMessage = reason.message;
      });
  }

  public onUnpurchase(): void {
    if (!this.itemService) {
      throw new Error('ShowItem.onUnpurchase: itemService is null or undefined');
    }

    const thisItem: Item = this.$props.item;
    if (!thisItem.purchasedByUserID) {
      throw new Error('Attempted to unpurchase an item that isn\'t purchased');
    }

    const localUser = this.$store.state.authenticationModule.localUser;
    if (!localUser) {
      throw new Error('ShowItem.onUnpurchase: localUser is null or undefined');
    }

    // TAB: Don't allow users to unpurchase items they didn't purchase!
    if (thisItem.purchasedByUserID !== localUser._id) {
      return;
    }

    this.itemService.unpurchaseItem(thisItem._id)
      .then(() => {
        this.errorMessage = null;
        this.purchasedByUsername = null;
        this.$emit('item-unpurchased');
      })
      .catch((reason: Error) => {
        console.error(`Failed to unpurchase item: ${thisItem._id}: Reason: ${reason}`);
        this.errorMessage = reason.message;
      });
  }
}
